import { useCallback, useSyncExternalStore } from 'react';

import {
  getPlaybackProgress,
  isPlaybackEnded,
  subscribePlaybackProgress,
  useAudioPlayer,
} from '@/stores/audioPlayer';

/**
 * playback-progress-ring — elapsed share of the preview while `audioId` is the
 * current sound and has not run to its end; null otherwise (no indicator).
 * Paused keeps its value: the element keeps its position, a tap resumes there.
 * Visibility is derived, never stored (design D2).
 */
export function usePlaybackProgress(audioId: string): number | null {
  // Re-render when this sound becomes, or stops being, the current one…
  const isCurrent = useAudioPlayer((s) => s.currentId === audioId);
  // …and on position updates only while it is: any other indicator's snapshot
  // stays null, so ~4 updates a second never redraw the whole list.
  const readProgress = useCallback(
    (): number | null => (isCurrent && !isPlaybackEnded() ? getPlaybackProgress() : null),
    [isCurrent],
  );
  return useSyncExternalStore(subscribePlaybackProgress, readProgress);
}
